export default __webpack_public_path__ + "static/media/features-1.81636770.gif";